import { DashboardDemoComponent } from './pages/dashboarddemo.component';
import { DashboardAnalyticsComponent } from './pages/dashboardanalytics.component';
import { FormLayoutDemoComponent } from './pages/formlayoutdemo.component';
import { InputDemoComponent } from './pages/inputdemo.component';
import { FloatLabelDemoComponent } from './pages/floatlabeldemo.component';
import { InvalidStateDemoComponent } from './pages/invalidstatedemo.component';
import { ButtonDemoComponent } from './pages/buttondemo.component';
import { TableDemoComponent } from './pages/tabledemo.component';
import { ListDemoComponent } from './pages/listdemo.component';
import { TreeDemoComponent } from './pages/treedemo.component';
import { PanelsDemoComponent } from './pages/panelsdemo.component';
import { OverlaysDemoComponent } from './pages/overlaysdemo.component';
import { MediaDemoComponent } from './pages/mediademo.component';
import { MenusDemoComponent } from './pages/menusdemo.component';
import { MessagesDemoComponent } from './pages/messagesdemo.component';
import { MiscDemoComponent } from './pages/miscdemo.component';
import { EmptyDemoComponent } from './pages/emptydemo.component';
import { ChartsDemoComponent } from './pages/chartsdemo.component';
import { FileDemoComponent } from './pages/filedemo.component';
import { DocumentationComponent } from './pages/documentation.component';
import { DisplayComponent } from './pages/display.component';
import { ElevationComponent } from './pages/elevation.component';
import { FlexboxComponent } from './pages/flexbox.component';
import { GridComponent } from './pages/grid.component';
import { IconsComponent } from './pages/icons.component';
import { WidgetsComponent } from './pages/widgets.component';
import { SpacingComponent } from './pages/spacing.component';
import { TypographyComponent } from './pages/typography.component';
import { TextComponent } from './pages/text.component';
import { AppCrudComponent } from './pages/templates/app.crud.component';
import { AppCalendarComponent } from './pages/templates/app.calendar.component';
import { AppTimelineDemoComponent } from './pages/templates/app.timelinedemo.component';
import { AppInvoiceComponent } from './pages/templates/app.invoice.component';
import { AppHelpComponent } from './pages/templates/app.help.component';
import { AppNotfoundComponent } from './pages/templates/app.notfound.component';
import { AppErrorComponent } from './pages/templates/app.error.component';
import { AppAccessdeniedComponent } from './pages/templates/app.accessdenied.component';
import { AppLoginComponent } from './pages/templates/app.login.component';

import { CountryService } from './service/countryservice';
import { CustomerService } from './service/customerservice';
import { EventService } from './service/eventservice';
import { IconService } from './service/iconservice';
import { NodeService } from './service/nodeservice';
import { PhotoService } from './service/photoservice';
import { ProductService } from './service/productservice';

export const DemoComponents = [
	DashboardDemoComponent,
	DashboardAnalyticsComponent,
	FormLayoutDemoComponent,
	InputDemoComponent,
	FloatLabelDemoComponent,
	InvalidStateDemoComponent,
	ButtonDemoComponent,
	TableDemoComponent,
	ListDemoComponent,
	TreeDemoComponent,
	PanelsDemoComponent,
	OverlaysDemoComponent,
	MediaDemoComponent,
	MenusDemoComponent,
	MessagesDemoComponent,
	MessagesDemoComponent,
	MiscDemoComponent,
	ChartsDemoComponent,
	EmptyDemoComponent,
	FileDemoComponent,
	DocumentationComponent,
	DisplayComponent,
	ElevationComponent,
	FlexboxComponent,
	GridComponent,
	IconsComponent,
	WidgetsComponent,
	SpacingComponent,
	TypographyComponent,
	TextComponent,
	AppCrudComponent,
	AppCalendarComponent,
	AppTimelineDemoComponent,
	AppLoginComponent,
	AppInvoiceComponent,
	AppHelpComponent,
	AppNotfoundComponent,
	AppErrorComponent,
	AppAccessdeniedComponent,
];

export const DemoProviders = [
	CountryService,
	CustomerService,
	EventService,
	IconService,
	NodeService,
	PhotoService,
	ProductService,
];
